$(document).on("click", '.restock-message-area',function (event) { 
   const $bisTrigger = $("#BIS_trigger");
  
    if ($bisTrigger.length) {
      setTimeout(function(){
              $bisTrigger.trigger('click'); 
      },100); 

    } 
});


 
$(document).on('click', '.variant-picker__option .SizeSwatch__Radio', function () {
  var color_name = $(this).attr('variant-option1');
  var variant_ID = $(this).attr('variant-id');
  var variant_available = $(this).attr('variant_available');

  // Update color swatch radio
  $('.color-options-grid.variant-picker__option-values input[type="radio"]').removeAttr('checked');
  $(`.color-options-grid.variant-picker__option-values input[option_name="${color_name}"]`).attr('checked', 'checked');

  // Redirect to the new variant URL (full reload)
  if (variant_ID) {
    $('form.shopify-product-form input[name="id"]').val(variant_ID); 
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant_ID); // Adds or replaces
    window.history.replaceState({}, '', url.toString());  
    let  $b_button =  $('#block-buy_buttons  .buy-buttons button[type="submit"]');
    if(variant_available == 'true'){
     $b_button.removeClass('button--outline');
      $b_button.removeAttr('disabled');
       $b_button.text(document.button_text.add_to_cart); 
    }else{ 
      $b_button.addClass('button--outline');
      $b_button.attr('disabled','disabled');
       $b_button.text(document.button_text.sold_out); 
    }
    
 
  }
});


$(document).on('click', '.color-options-grid.variant-picker__option-values input[type="radio"]', function() {
    var option_name = $(this).attr('option_name'); 
    $('.variant-picker__option .SizeSwatch__Radio').prop('checked', false); 
    $(`.variant-picker__option .SizeSwatch__Radio[variant-option1="${option_name}"]`).first().trigger('click'); 
});









